$(document).ready(function () {

	$('.fitt-header .menu-item-has-children > a').click(function (e) {
		e.preventDefault();
		e.stopPropagation();
		const t = $(this);
		const target = t.closest('.menu-item-has-children');

		// Overlay
		const menuOverlay = $('.header-menu .menu-overlay');

		if (target.hasClass('active')) {
			target.removeClass('active');
			// On vérifie si le premier menu
			const test = target.closest('.sub-menu')
			if (test.length === 0) {
				menuOverlay.removeClass('active');
			}

		} else {
			const ctx = t.closest('.sub-menu');
			$('.menu-item-has-children', ctx).removeClass('active');
			target.addClass('active');
			menuOverlay.addClass('active')
		}
	})

	$('.header-menu .menu-overlay').click(function (e) {
		$('.fitt-header .menu-item-has-children').removeClass('active')
		$(this).removeClass('active')
	})
	
	// Loader submit form
	const loader = document.getElementById("form-loader");

	function showLoader() {
		if (loader) loader.style.display = "flex";
		document.body.classList.add("form-loading");
	}

	function hideLoader() {
		if (loader) loader.style.display = "none";
		document.body.classList.remove("form-loading");
	}

	// Sélecteur de ton formulaire newsletter
	const NEWSLETTER_FORM_ID = '184965';

	document.querySelectorAll("form").forEach(form => {
		// Vérifie si c’est un formulaire CF7 de newsletter
		const isNewsletterForm =
			form.querySelector('input[name="_wpcf7"]')?.value === NEWSLETTER_FORM_ID;

		if (
			form.classList.contains("woocommerce-cart-form") ||
			form.id === "cart" ||
			isNewsletterForm // ⛔ exclusion précise ici
		) {
			return;
		}

		form.addEventListener("submit", function () {
			showLoader();
		});
	});

	// Cache le loader à la fin des formulaires CF7
	document.addEventListener('wpcf7mailsent', hideLoader);
	document.addEventListener('wpcf7mailfailed', hideLoader);
	document.addEventListener('wpcf7invalid', hideLoader);
})